const INVALID_TEXT_LINK_IDS = ["null", "undefined"];

export const isValidTextLinkId = (textLinkId: string | null | undefined): textLinkId is string => {
  if (!textLinkId) {
    return false;
  }
  const normalized = textLinkId.trim().toLowerCase();
  return normalized.length > 0 && !INVALID_TEXT_LINK_IDS.includes(normalized);
};
